import React, { Component } from "react";
const isEmpty = require("is-empty");

class RolModalComponent extends Component {

	state = {
		_id:                "",
		is_active:          "",
		name:               "",
		errorName:          "",
		isValidName:        false,
		description:        "",
		errorDescription:   "",
		isValidDescription: false,
		key:                "",
		errorKey:           "",
		isValidKey:         false,
	}

  	constructor(props) {
		super(props);
		this.onChangeDescription = this.onChangeDescription.bind(this);
		this.preparateCreate     = this.preparateCreate.bind(this);
		this.preparateUpdate     = this.preparateUpdate.bind(this);
		this.onPressCancel       = this.onPressCancel.bind(this);
		this.deactivateRol       = this.deactivateRol.bind(this);
		this.onChangeName        = this.onChangeName.bind(this);
		this.activateRol         = this.activateRol.bind(this);
		this.escFunction         = this.escFunction.bind(this);
		this.onChangeKey         = this.onChangeKey.bind(this);
	}

  	componentDidMount() {
		document.addEventListener("keydown", this.escFunction, false);
	}

	componentDidUpdate(prevProps) {
		if (this.props.modalRolData) {
			if (this.props.modalRolData !== prevProps.modalRolData) {
				this.setState({
					_id: this.props.modalRolData._id,
					name: this.props.modalRolData.name,
					description: this.props.modalRolData.description,
					key: this.props.modalRolData.key,
					is_active: this.props.modalRolData.is_active
				})
			}
		}
	}


 	///---------------------------------------EVENTS-------------------------------------
  	escFunction(event) {
		if (event.keyCode === 27) {
			this.props.onPressCancel();
		}
	}

	async preparateCreate() {
		await this.clearErrors();
		this.validate();
		if (this.state.isValidName && this.state.isValidDescription && this.state.isValidKey) {
			this.props.createRol(
				this.state.name,
				this.state.description,
				this.state.key,
			);
			this.cleanForm();
		}
	}

	async preparateUpdate() {
		await this.clearErrors();
		this.validate();
		if (this.state.isValidName && this.state.isValidDescription && this.state.isValidKey) {
			this.props.updateRol(
				this.state._id,
				this.state.name,
				this.state.description,
				this.state.key,
			);
			this.cleanForm();
		}
	}

  	activateRol() {
		this.props.activateRol(this.props.modalRolData._id);
	}

	deactivateRol() {
		this.props.deactivateRol(this.props.modalRolData._id);
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.setState({
			description: '',
			name: '',
			key: '',
			errorDescription: '',
			errorName: '',
			errorKey: '',
		}, () => {
			this.props.onPressCancel();
		})
	}

  	onChangeName(e) {
		this.setState({
			name: e.target.value,
		})
	}

  	onChangeDescription(e) {
		this.setState({
			description: e.target.value,
		})
	}

  	onChangeKey(e) {
		this.setState({
			key: e.target.value,
		})
	}

  	clearErrors() {
		this.setState({
			errorDescription: "",
			errorName:        "",
			errorKey:         "",
		})
	}

  	cleanForm() {
		this.farmazonFormRef.reset();
		this.setState({
			description:      "",
			name:             "",
			key:              "",
			errorDescription: "",
			errorName:        "",
			errorKey:         "",
		});
	}

  	validate() {
    	if (this.state.name === "" || isEmpty(this.state.name)) {
			this.setState({
				errorName: "El nombre del rol es requerido."
			})
		} 
		else {
			this.setState({
				isValidName: true
			})
		}

   		if (this.state.description === "" || isEmpty(this.state.description)) {
			this.setState({
				errorName: "La descripción del rol es requerida."
			})
		} 
		else {
			this.setState({
				isValidDescription: true
			})
		}   
    
    	if (this.state.key === "" || isEmpty(this.state.key)) {
			this.setState({
				errorName: "La clave del rol es requerida."
			})
		} 
		else {
			this.setState({
				isValidKey: true
			})
		} 
  	}


  ///---------------------------------------VIEW-------------------------------------
  render() {
    	var title = "CREACIÓN DE ROL";
		if (this.props.type === 'UPDATE') {
			title = "ACTUALIZACIÓN DEL ROL";
		}

		return (
			<div className={this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-user-main">
					<div className="auth-group">
						{title}
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						{
							<form ref={(el) => { this.farmazonFormRef = el }}>
							{
								<div className="auth-label">
									Nombre:
									<span className="required">*</span>
									<input
										id="nameForm"
										onChange={this.onChangeName}
										value={this.state.name || ""}
										error={this.state.errorName}
										type="title"
										placeholder={this.props.modalRolData ? this.props.modalRolData.name : "Ej.: Cliente"}
										className="local-store-input"
									/>
								</div>
							}
								<div className="auth-error">{this.state.errorName}</div>
							{
								<div className="auth-label">
									Descripción:
									<span className="required">*</span>
									<input
										id="descriptionForm"
										onChange={this.onChangeDescription}
										value={this.state.description}
										error={this.state.errorDescription}
										type="title"
										placeholder={this.props.modalRolData ? this.props.modalRolData.description : "Ej.: Rol del cliente farmazon."}
										className="local-store-input"
									/>
								</div>
							}
							<div className="auth-error">{this.state.errorDescription}</div>
							{
								<div className="auth-label">
									Clave:
									<span className="required">*</span>
									<input
										id="keyForm"
										onChange={this.onChangeKey}
										value={this.state.key}
										error={this.state.errorKey}
										type="title"
										placeholder={this.props.modalRolData ? this.props.modalRolData.key : "Ej.: B2B"}
										className="local-store-input"
									/>
								</div>
							}
								<div className="auth-error">{this.state.errorKey}</div>
								<div className="auth-label"></div>
								<div className="auth-label"></div>
								<div className="auth-error">{this.props.error}</div>
							</form>
						}

						<div className="modal-activity-section">
						{
							this.props.type === 'UPDATE' &&
							<button className="modal-buttonOK" onClick={this.preparateUpdate}>ACTUALIZAR</button>
						}
						{
							this.props.type !== 'UPDATE' &&
							<button className="modal-buttonOK" onClick={this.preparateCreate}>GUARDAR</button>
						}
						{
							this.props.type === 'UPDATE' &&
							this.props.modalRolData &&
							this.props.modalRolData.is_active === false &&
							<button className="modal-buttonActivate" onClick={this.activateRol}>ACTIVAR</button>
						}
						{
							this.props.type === 'UPDATE' &&
							this.props.modalRolData &&
							this.props.modalRolData.is_active &&
							<button className="modal-buttonDelete" onClick={this.deactivateRol}>DESACTIVAR</button>
						}
						{
							<button className="modal-buttonNo" onClick={this.onPressCancel}>CERRAR</button>
						}
						</div>
					</div>
				</div>
			</div>
		);
  }
}
export default RolModalComponent;